import useApi from "./useApiRequest";
import { useMutation, useQuery } from "react-query";

export const GetAllPartesClienteList = (emp_id)  => {
    const api = useApi();

    const mutate = async () => {
        const data  = await api.get(`/partes/list?emp=${emp_id}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getAllPartesClienteListMutation: mutation.mutate,
    };
}

export const GetPartsClientsList = (emp_id)  => {
    const api = useApi();
    return useQuery(['list_client_parts', emp_id], async () => {
        const { data } = await api.get(`/partes/list?emp=${emp_id}`);
        return data;
    }, {
        refetchOnWindowFocus: false,
        retry: false,
        enabled: !!emp_id
    });
}